import script from "./NftConstructorButton.vue?vue&type=script&setup=true&lang=js"
export * from "./NftConstructorButton.vue?vue&type=script&setup=true&lang=js"

import "./NftConstructorButton.vue?vue&type=style&index=0&id=3903eba9&lang=scss"

const __exports__ = script;

export default __exports__